var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 10.8391L11.002 7.36431H7.66788V5.10944C7.66788 4.15881 8.13363 3.23219 9.62688 3.23219H11.1426V0.273813C11.1426 0.273813 9.76713 0.0390625 8.452 0.0390625C5.70625 0.0390625 3.9115 1.70331 3.9115 4.71606V7.36431H0.859375V10.8391H3.9115V19.2391H7.66788V10.8391H10.4688Z",
    fill: "#191916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLightIcon);
export default __webpack_public_path__ + "static/media/facebookLightIcon.36e43215266194ecc56716d113f8edd3.svg";
export { ForwardRef as ReactComponent };